<ui-form-chip-control-group overlayFormClass="order-history-filter-sort-overlay-form" (valueChange)="handleValueChange($event)" [inputItems]="inputItems()" resetAllLabel="Alle Filter zurücksetzen"></ui-form-chip-control-group>
